import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
	isVisible: boolean;
	title: string;
	message: string;
	userId: any;
}

const initialState: ModalState = {
	isVisible: false,
	title: "",
	message: "",
	userId: "",
};

const messageModalSlice = createSlice({
	name: "modal",
	initialState,
	reducers: {
		showMessageModal: (
			state,
			action: PayloadAction<{
				title: string;
				message: string;
				userId: any;
			}>
		) => {
			state.isVisible = true;
			state.title = action.payload.title;
			state.message = action.payload.message;
			state.userId = action.payload.userId;
		},
		hideMessageModal: (state) => {
			state.isVisible = false;
			state.title = "";
			state.message = "";
			state.userId = "";
		},
	},
});

export const { showMessageModal, hideMessageModal } = messageModalSlice.actions;
export default messageModalSlice.reducer;
